import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { SettingsProvider } from './settings.service';
import { map } from 'rxjs/operators';

export class UserProfileModel {
    id: string;
    displayName: string;
    givenName: string;
    mail: string;
    surename: string;
    userPrincipalName: string;
    mobile: string;
    officePhoneNumber: string;
    surname: string;
    accountEnabled: boolean;
}

@Injectable()
export class UserProfileDataService {
    constructor(
        private http: HttpService,
        public settingsService: SettingsProvider
    ) {}

    public fetchUserProfile(): Observable<UserProfileModel> {
        return this.http.get(
            `${this.settingsService.configuration.url}${env.ProfileDataService.apiUrlGetProfile}`
        );
    }
    
    public getProfileGroups(userId: string): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.ActiveUsersDataService.apiUrlGetActiveUserGroups}(UserId='${userId}')`;
        return this.http.get(url).pipe(map((response) => response.value));
    }

    public getProfilePermissionsList(): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.ProfileDataService.apiUrlGetProfilePermissionsList}`;
        return this.http.get(url);
    }
}
